import styled from 'styled-components'

import {
  DEVICE,
  NAVIGATION_BAR_COLLAPSED_SIZE,
  NAVIGATION_MENU_EXPANDED_WIDTH_DESKTOP,
} from '../../../util/constants'
import { MENU_SIZE_TRANSITION_DURATION } from '../../PrimaryNavigation/styles/ExpandedMenu.styles'

const openNavMenuOffset =
  NAVIGATION_MENU_EXPANDED_WIDTH_DESKTOP -
  NAVIGATION_BAR_COLLAPSED_SIZE.desktop.width

export const Container = styled.div`
  background-color: var(--content-background-light);
  bottom: 80px; /* Position above anchor ad */
  display: flex;
  left: 0;
  flex-direction: column;
  justify-content: center;
  opacity: ${props => (props.isVisible ? 1 : 0)};
  padding: 20px 40px 15px; /* Reduced padding to reduce footprint */
  position: fixed;
  right: 0;
  text-align: center;
  transform: translateY(${props => (props.isVisible ? 0 : '100%')});
  transition: transform ${MENU_SIZE_TRANSITION_DURATION},
    opacity ${MENU_SIZE_TRANSITION_DURATION} 0.05s;
  z-index: 100;

  @media ${DEVICE.tabletL} {
    left: ${NAVIGATION_BAR_COLLAPSED_SIZE.desktop.width}px;
    transform: translateX(
        ${props => (props.isNavMenuOpen ? `${openNavMenuOffset}px` : 0)}
      )
      translateY(${props => (props.isVisible ? 0 : '100%')});
  }

  /* Mobile adjustments for smaller screens */
  @media (max-width: 768px) {
    bottom: 100px; /* Increased offset to account for taller donation popup */
    padding: 15px 20px 10px; /* Even smaller padding on mobile */
  }

  /* Tablet adjustments */
  @media (min-width: 769px) and (max-width: 1024px) {
    bottom: 90px; /* Slightly higher than desktop for tablet */
  }
`

export const TextContainer = styled.div`
  color: var(--content-background-dark-blue);
  font-size: 1.4rem; /* Reduced from 1.6rem */
  margin: 0 auto 15px; /* Reduced from 20px */
  max-width: 800px;

  a:hover,
  a:focus {
    color: var(--content-background-dark-blue);
  }
`

export const Button = styled.button`
  align-items: center;
  align-self: center;
  background-color: var(--highlight-blue);
  border: 2px solid var(--highlight-blue);
  color: #fff;
  display: flex;
  justify-content: center;
  min-width: 100px; /* Reduced from 122px */
  padding: 10px 25px; /* Reduced from 13px 30px */

  &:hover,
  &:focus {
    background-color: transparent;
    color: var(--content-background-dark-blue);
  }
`

export const ButtonLabel = styled.span`
  font-size: 1.2rem; /* Reduced from 1.4rem */
  font-weight: bold;
  text-transform: uppercase;
`
